import script from "./familyPrinter.vue?vue&type=script&setup=true&lang=js"
export * from "./familyPrinter.vue?vue&type=script&setup=true&lang=js"

import "./familyPrinter.vue?vue&type=style&index=0&id=781ca1b1&lang=scss"

const __exports__ = script;

export default __exports__